module.exports = __webpack_public_path__ + "static/media/banner_desktop.a82498b0.png";